import PageIcon from './pageicon';
import UserActivity from './useractivity';
import Settings from './settings';
import Chat from './chat';

let Notifier = {
	playSound(){
		if (Settings.sound){
			let a = document.querySelector('audio.chat-audio-notification');
			if (a && a.play){
				a.play();
			}
		}
	},

	rollIcon(){
		if (Settings.icon){
			PageIcon.startRolling();
		}
	},

	showNotification(title, body){
		if (Settings.isNotificationPermissionGranted()){
			let n = new Notification(title, {
				body: body.substr(0, 128),
			});
			setTimeout(n.close.bind(n), 6000);
		}
	},

	message(room, login, msg){
		if (!UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.notifyAll){
				this.showNotification('[' + room + '] ' + login, msg);
			}
		}
	},

	online(room, login, msg){
		if (Settings.statusMessageNotifications && !UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.notifyAll){
				this.showNotification('[' + room + ']', login + ' ' + msg);
			}
		}
	},

	mention(room, login, msg){
		if (!UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.mention){
				this.showNotification('[' + room + '] ' + login, msg);
			}
		}
	},
};

export default Notifier;
